import { Button } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTWCL_Go_to_My_Bets,
  TXTWCL_Re_use_Selection,
  TXTWCL_Re_use_Selections
} from './Footer.messages.json';
import styles from './Footer.scss';

const ReceiptFooter: React.FC = () => {
  const receiptSingles = useSelector(select.betSlip.singleOpportunities);
  const dispatch = useDispatch<Dispatch>();

  return (
    <div className={styles.footer} data-testid="bet-receipt-footer">
      <Button variant="secondary" onClick={dispatch.betSlip.selectionsReused} size="medium">
        {receiptSingles.length === 1 ? (
          <Translation {...TXTWCL_Re_use_Selection} />
        ) : (
          <Translation {...TXTWCL_Re_use_Selections} />
        )}
      </Button>
      <Button as={Link} alias="sportsMyBets" values={{ status: 'open' }} size="medium">
        <Translation {...TXTWCL_Go_to_My_Bets} />
      </Button>
    </div>
  );
};

export default ReceiptFooter;
